// extracted by mini-css-extract-plugin
export var columnList = "_ef-0";